function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevatorBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "elevator_broken") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0A11.9,11.9,0,0,0,4.4,2.7,13.7,13.7,0,0,0,2.7,4.4,12,12,0,0,0,19.6,21.3l1.7-1.7A12,12,0,0,0,12,0Zm-.7,20.2H7.1a.9.9,0,0,1-.9-.9V4.7a.9.9,0,0,1,.9-.9h4.2Zm6.5-.9a.9.9,0,0,1-.9.9H12.7V3.8h4.2a.9.9,0,0,1,.9.9Zm-7.5-8.4-.5-.5-1.1,1-1-1-.5.5,1.5,1.6Z",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3,19.6l-1.7,1.7L2.7,4.4A13.7,13.7,0,0,1,4.4,2.7Z",
    style: {
      fill: "#e30613"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatorBroken);
export default __webpack_public_path__ + "static/media/elevator_broken.11d9697b52710fdcabdf431bde127da7.svg";
export { ForwardRef as ReactComponent };